// Where grid cards draw the shop's labels (ui.showProductTags):
//   'photo' — stacked on the photo's top-left corner (option B, what ships)
//   'under' — a fixed two-row strip under the photo (option A, aligned cards)
//
// Only the /demo/bazaar switcher changes it (founder, 2026-10-21: show the
// client both designs side by side). Everyone else, and every embed, stays on
// 'photo' — nothing outside the demo page ever calls setTagsLayout.

export type TagsLayout = 'photo' | 'under';

let current: TagsLayout = 'photo';
const listeners = new Set<() => void>();

export function getTagsLayout(): TagsLayout {
  return current;
}

export function setTagsLayout(next: TagsLayout): void {
  if (next === current) return;
  current = next;
  listeners.forEach((l) => l());
}

export function subscribeTagsLayout(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Server render always uses the shipped layout. */
export function getServerTagsLayout(): TagsLayout {
  return 'photo';
}
